import {
  getLoggedInUserId,
  loggedInUserRunAsLabel,
} from '../../utils/dashboardRunUserLabel';

export const labelToName = (label) => {
  if (!label || typeof label !== 'string') return '';
  return label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '') || '';
};

export const resolveDashboardOwnerId = (dashboard) => {
  if (!dashboard) return '';
  const id = dashboard.ownerid ?? dashboard.owner_id;
  return id != null ? String(id).trim() : '';
};

/** Human-readable owner label for lookups and forms (empty if unknown). */
export const formatDashboardOwnerLabel = (dashboard) => {
  if (!dashboard) return '';
  const name = (dashboard.created_by_name || '').trim();
  if (name) return name;
  const email = (dashboard.created_by_email || '').trim();
  if (email) return email;
  const username = (dashboard.created_by_username || '').trim();
  if (username) return username;
  return '';
};

/** Owner label for table cells (dash when unknown). */
export const formatDashboardOwner = (dashboard) => {
  const label = formatDashboardOwnerLabel(dashboard);
  return label || '—';
};

export const emptyDashboardForm = () => ({
  name: '',
  label: '',
  description: '',
  view_type: 'STATIC_USER',
  running_user_id: '',
  owner_id: '',
  owner_label: '',
});

export const dashboardFormFromRecord = (dashboard) => {
  const vt = dashboard?.view_type || 'STATIC_USER';
  const ru =
    dashboard?.running_user_id != null && String(dashboard.running_user_id).trim()
      ? String(dashboard.running_user_id).trim()
      : vt === 'STATIC_USER'
        ? getLoggedInUserId()
        : '';
  return {
    name: dashboard?.name || '',
    label: dashboard?.label || '',
    description: dashboard?.description || '',
    view_type: vt,
    running_user_id: ru,
    owner_id: resolveDashboardOwnerId(dashboard),
    owner_label: formatDashboardOwnerLabel(dashboard),
  };
};

export const normalizeDashboardPayload = (raw) => {
  const payload = { ...raw };
  delete payload.is_global_default;
  delete payload.owner_label;
  if (payload.owner_id) {
    payload.ownerid = String(payload.owner_id).trim();
  }
  delete payload.owner_id;
  if (payload.view_type === 'LOGGED_IN_USER') {
    delete payload.running_user_id;
  } else {
    const uid =
      (payload.running_user_id && String(payload.running_user_id).trim()) ||
      getLoggedInUserId();
    payload.running_user_id = uid || null;
  }
  return payload;
};

export const createDashboardFormDefaults = () => {
  const me = getLoggedInUserId();
  return {
    ...emptyDashboardForm(),
    running_user_id: me || '',
    owner_id: me || '',
    owner_label: loggedInUserRunAsLabel(),
  };
};
